var map = {
	"./de-BE.json": [
		26586,
		6586
	],
	"./en-GB.json": [
		27274,
		7274
	],
	"./fr-BE.json": [
		85139,
		5139
	],
	"./nl-BE.json": [
		57725,
		7725
	],
	"./nl-NL.json": [
		15122,
		5122
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32145;
module.exports = webpackAsyncContext;